import store, {typedStore} from '@/store';
import router from '@/router';
import {AxiosResponse} from 'axios';

// surely something like this exists in typescript already, but i can't find it.
// replace this if you come across this and know a better way.
// i used enum in case we want to extend this file someday to include
// situations other than 401 errors.
enum HttpStatusCode {
    Unauthorized = 401
}

// the error parameter really is of type any, per the interface of the
// AxiosInterceptorManager that provides the parameter.
export function onResponseRejectedRerouteUnauthorizedRequest(error: any): Promise<never> | Promise<void> {
    if (!error.response) {
        // return a Promise<void> so anything calling this can still use
        // .then(...) actions after this method.
        return Promise.resolve();
    }

    const response = error.response as AxiosResponse;
    const pendingRoute = typedStore.getters.pendingNavigation;
    const pendingRoot = pendingRoute?.matched[0];

    if (response.status === HttpStatusCode.Unauthorized
        && pendingRoute
        && pendingRoute.name !== 'vatsLogin'
        && pendingRoute.name !== 'login'
        && pendingRoot?.name !== 'internalExternal') {

        const previousRoute = {
            params: pendingRoute.params,
            name: pendingRoute.name,
            query: pendingRoute.query,
        };

        store.commit('userModule/setReturnAfterLogin', previousRoute);

        // noinspection JSIgnoredPromiseFromCall
        router.push({name: 'vatsLogin'});
    }

    return Promise.reject(error);
}
